export default "/assets/images/hero_mila2.e0123c4549e5250a.png";